var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("input", {
    ref: "checkbox",
    staticClass: "ag-checkbox-input",
    attrs: { type: "checkbox", disabled: _vm.isDisabled },
    domProps: { checked: _vm.isAllSelected },
    on: { change: _vm.handleSelectAll },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }